import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    standalone: false
})
export class AlertComponent {
	private DEFAULT_TITLE_KEY: string = 'financials.title';
	private SECTION_TITLE_KEYS: { [property: string]: string[] } = {
		application: ['energyUsage.title', 'financials.title'],
		contractYear: ['financials.title', 'incentives.title'],
		contractMonth: ['financials.title', 'incentives.title'],
	};
	@Output() switchValue = new EventEmitter();
	@Input() public modalIsOpen: boolean = false;
	@Input() public alertMaps: Map<String, Array<String[]>> = new Map<String, Array<String[]>>();
	@Input() public property: string;

	public closeModal() {
		this.modalIsOpen = false;
		this.switchValue.emit(this.modalIsOpen);
	}

	public getSectionTitleKey(property: string, index: number): string {
		const keys = this.SECTION_TITLE_KEYS[property];
		if (keys && keys[index]) {
			return keys[index];
		}
		return this.DEFAULT_TITLE_KEY;
	}
}
